import config from "../config";
import { getSession } from "../utils";
import { formatUtc } from "../utc";

const authHeaders = () => ({ "user-authorization": getSession().token });

const ensureOk = async (response) => {
    if (response.ok) return response;
    let detail = `${response.status} ${response.statusText}`;
    try {
        const body = await response.json();
        if (body && body.detail) {
            detail = typeof body.detail === "string" ? body.detail : JSON.stringify(body.detail);
        }
    } catch {
        detail = `${response.status} ${response.statusText}`;
    }
    throw new Error(detail);
};

export const STATUSES = ["open", "answered", "closed"];

export const STATUS_LABELS = {
    open: "Waiting for support",
    answered: "Answered",
    closed: "Closed",
};

export const fetchTickets = async ({ status, q, limit, offset }) => {
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    if (q) params.set("q", q);
    params.set("limit", String(limit));
    params.set("offset", String(offset));
    const response = await fetch(`${config.apiBaseUrl}/admin/support/tickets?${params.toString()}`, {
        headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return (await ensureOk(response)).json();
};

export const fetchTicket = async (ticketId) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/support/tickets/${ticketId}`, {
        headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    return (await ensureOk(response)).json();
};

export const replyToTicket = async (ticketId, body, files) => {
    const form = new FormData();
    form.append("body", body);
    files.forEach((file) => form.append("files", file, file.name));
    const response = await fetch(`${config.apiBaseUrl}/admin/support/tickets/${ticketId}/messages`, {
        method: "POST",
        headers: authHeaders(),
        body: form,
    });
    return (await ensureOk(response)).json();
};

export const updateTicketStatus = async (ticketId, status) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/support/tickets/${ticketId}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json", ...authHeaders() },
        body: JSON.stringify({ status }),
    });
    return (await ensureOk(response)).json();
};

export const downloadAttachment = async (attachment) => {
    const response = await fetch(`${config.apiBaseUrl}/admin/support/attachments/${attachment.id}`, {
        headers: authHeaders(),
    });
    const blob = await (await ensureOk(response)).blob();
    const url = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = url;
    anchor.download = attachment.file_name;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.setTimeout(() => URL.revokeObjectURL(url), 10000);
};

export const formatDate = (value) => formatUtc(value, "—");

export const formatSize = (bytes) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
